(function () {
  if (window.__me2627Initialized) return;
  window.__me2627Initialized = true;

  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function smoothScroll(targetId) {
    var target = document.getElementById(targetId);
    if (!target) return;
    target.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-me2627-scroll]');
    if (!trigger) return;
    event.preventDefault();
    smoothScroll(trigger.getAttribute('data-me2627-scroll'));
  });

  if (!prefersReducedMotion && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    document.querySelectorAll('.me2627-reveal').forEach(function (node) {
      observer.observe(node);
    });
  } else {
    document.querySelectorAll('.me2627-reveal').forEach(function (node) {
      node.classList.add('is-visible');
    });
  }

  /* Logo nav : grand en haut, compact au scroll */
  var nav = document.querySelector('.me2627-nav');
  if (nav) {
    var navScrollTicking = false;
    var updateNavScroll = function () {
      nav.classList.toggle('is-scrolled', window.scrollY > 56);
      navScrollTicking = false;
    };
    window.addEventListener('scroll', function () {
      if (navScrollTicking) return;
      navScrollTicking = true;
      window.requestAnimationFrame(updateNavScroll);
    }, { passive: true });
    updateNavScroll();
    window.addEventListener('me2627:intro-done', updateNavScroll);
  }

  /* Sticky CTA : fixed bas droite (pas d’arrêt footer — évite le bug en fin de scroll) */

  document.querySelectorAll('[data-me2627-slider]').forEach(function (root) {
    var track = root.querySelector('[data-me2627-slider-track]');
    var inner = root.querySelector('[data-me2627-slider-inner]');
    var slides = inner ? Array.prototype.slice.call(inner.querySelectorAll('[data-me2627-slide]')) : [];
    var prev = root.querySelector('[data-me2627-slider-prev]');
    var next = root.querySelector('[data-me2627-slider-next]');
    var pauseBtn = root.querySelector('[data-me2627-slider-pause]');
    var progress = root.querySelector('[data-me2627-slider-progress]');
    var autoplayDelay = parseInt(root.getAttribute('data-me2627-slider-delay'), 10) || 5500;
    var activeIndex = 0;
    var currentVisualIndex = 0;
    var autoplayTimer = null;
    var scrollTicking = false;
    var scrollEndTimer = null;
    var autoplayEnabled = slides.length > 1 && !prefersReducedMotion;
    var autoplayPaused = false;
    var loopEnabled = slides.length > 1;
    var progressRatio = 0;
    var remainingMs = autoplayDelay;

    if (!track || !inner || !slides.length) return;

    if (loopEnabled) {
      var firstClone = slides[0].cloneNode(true);
      var lastClone = slides[slides.length - 1].cloneNode(true);
      firstClone.setAttribute('data-me2627-clone', 'true');
      lastClone.setAttribute('data-me2627-clone', 'true');
      inner.appendChild(firstClone);
      inner.insertBefore(lastClone, inner.firstChild);
    }

    function slideWidth() {
      return track.clientWidth;
    }

    function updateActiveSlide(index) {
      slides.forEach(function (slide, slideIndex) {
        slide.setAttribute('aria-hidden', slideIndex === index ? 'false' : 'true');
      });
    }

    function getProgressScale() {
      if (!progress) return progressRatio;
      var transform = window.getComputedStyle(progress).transform;
      if (!transform || transform === 'none') return progressRatio;
      var parts = transform.replace('matrix3d(', '').replace('matrix(', '').replace(')', '').split(',');
      var scale = parseFloat(parts[0]);
      return isNaN(scale) ? progressRatio : scale;
    }

    function clearAutoplayTimer() {
      if (autoplayTimer) {
        window.clearTimeout(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function resetProgressBar() {
      progressRatio = 0;
      remainingMs = autoplayDelay;
      if (!progress) return;
      progress.style.transition = 'none';
      progress.style.transform = 'scaleX(0)';
    }

    function freezeProgressBar() {
      if (!progress) return;
      progressRatio = Math.max(0, Math.min(1, getProgressScale()));
      remainingMs = Math.max(80, Math.round((1 - progressRatio) * autoplayDelay));
      progress.style.transition = 'none';
      progress.style.transform = 'scaleX(' + progressRatio + ')';
    }

    function runProgressBar(fromRatio, duration) {
      if (!progress || !autoplayEnabled || autoplayPaused) return;
      progressRatio = fromRatio;
      progress.style.transition = 'none';
      progress.style.transform = 'scaleX(' + fromRatio + ')';
      progress.offsetWidth;
      progress.style.transition = 'transform ' + duration + 'ms linear';
      progress.style.transform = 'scaleX(1)';
    }

    function startAutoplay(resume) {
      if (!autoplayEnabled || autoplayPaused) return;
      clearAutoplayTimer();

      var duration = resume ? remainingMs : autoplayDelay;
      var from = resume ? progressRatio : 0;
      if (!resume) {
        progressRatio = 0;
        remainingMs = autoplayDelay;
      }

      runProgressBar(from, duration);
      autoplayTimer = window.setTimeout(function () {
        progressRatio = 0;
        remainingMs = autoplayDelay;
        if (loopEnabled) {
          goToVisualIndex(currentVisualIndex + 1);
        } else {
          goToSlide(activeIndex + 1);
        }
      }, duration);
    }

    function setAutoplayPaused(paused) {
      autoplayPaused = !!paused;
      root.classList.toggle('is-paused', autoplayPaused);
      if (pauseBtn) {
        pauseBtn.setAttribute('aria-pressed', autoplayPaused ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', autoplayPaused ? 'Reprendre' : 'Mettre en pause');
      }
      if (autoplayPaused) {
        clearAutoplayTimer();
        freezeProgressBar();
      } else {
        startAutoplay(true);
      }
    }

    function jumpToVisual(index) {
      currentVisualIndex = index;
      track.scrollTo({ left: slideWidth() * index, behavior: 'auto' });
    }

    function normalizeVisualIndex() {
      if (!loopEnabled) return currentVisualIndex;
      if (currentVisualIndex <= 0) {
        jumpToVisual(slides.length);
      } else if (currentVisualIndex >= slides.length + 1) {
        jumpToVisual(1);
      }
      return currentVisualIndex;
    }

    function goToVisualIndex(index) {
      if (loopEnabled) {
        var maxVisual = slides.length + 1;
        if (index < 0) index = 0;
        if (index > maxVisual) index = maxVisual;
      }

      currentVisualIndex = index;
      if (!loopEnabled) {
        activeIndex = Math.max(0, Math.min(index, slides.length - 1));
      } else if (index <= 0) {
        activeIndex = slides.length - 1;
      } else if (index >= slides.length + 1) {
        activeIndex = 0;
      } else {
        activeIndex = index - 1;
      }
      track.scrollTo({
        left: slideWidth() * index,
        behavior: prefersReducedMotion ? 'auto' : 'smooth'
      });
      updateActiveSlide(activeIndex);
      if (autoplayPaused) {
        clearAutoplayTimer();
        resetProgressBar();
      } else {
        startAutoplay(false);
      }
    }

    function goToSlide(index) {
      var safeIndex = (index + slides.length) % slides.length;
      goToVisualIndex(loopEnabled ? safeIndex + 1 : safeIndex);
    }

    function syncFromScrollPosition() {
      var width = Math.max(slideWidth(), 1);
      var nearestVisualIndex = Math.round(track.scrollLeft / width);
      if (loopEnabled) {
        nearestVisualIndex = Math.max(0, Math.min(nearestVisualIndex, slides.length + 1));
      } else {
        nearestVisualIndex = Math.max(0, Math.min(nearestVisualIndex, slides.length - 1));
      }
      currentVisualIndex = nearestVisualIndex;

      if (!loopEnabled) {
        activeIndex = nearestVisualIndex;
        updateActiveSlide(activeIndex);
        return;
      }

      if (nearestVisualIndex <= 0) {
        activeIndex = slides.length - 1;
      } else if (nearestVisualIndex >= slides.length + 1) {
        activeIndex = 0;
      } else {
        activeIndex = nearestVisualIndex - 1;
      }
      updateActiveSlide(activeIndex);
    }

    function settleLoopPosition() {
      if (!loopEnabled) return;
      if (currentVisualIndex <= 0) {
        jumpToVisual(slides.length);
      } else if (currentVisualIndex >= slides.length + 1) {
        jumpToVisual(1);
      }
    }

    track.addEventListener('wheel', function (event) {
      if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
        event.preventDefault();
      }
    }, { passive: false });

    track.addEventListener('scroll', function () {
      if (scrollTicking) return;
      scrollTicking = true;
      window.requestAnimationFrame(function () {
        syncFromScrollPosition();
        scrollTicking = false;
      });
      if (scrollEndTimer) window.clearTimeout(scrollEndTimer);
      scrollEndTimer = window.setTimeout(function () {
        settleLoopPosition();
      }, 180);
    }, { passive: true });

    if (prev) {
      prev.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (loopEnabled) {
          var from = normalizeVisualIndex();
          goToVisualIndex(from - 1);
        } else {
          goToSlide(activeIndex - 1);
        }
      });
    }

    if (next) {
      next.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (loopEnabled) {
          var from = normalizeVisualIndex();
          goToVisualIndex(from + 1);
        } else {
          goToSlide(activeIndex + 1);
        }
      });
    }

    if (pauseBtn && autoplayEnabled) {
      pauseBtn.addEventListener('click', function () {
        setAutoplayPaused(!autoplayPaused);
      });
    } else if (pauseBtn) {
      pauseBtn.hidden = true;
    }

    updateActiveSlide(0);
    if (loopEnabled) {
      jumpToVisual(1);
    } else {
      jumpToVisual(0);
    }
    if (autoplayEnabled) {
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          if (!autoplayPaused) {
            clearAutoplayTimer();
            freezeProgressBar();
          }
        } else if (!autoplayPaused) {
          startAutoplay(true);
        }
      });
      startAutoplay(false);
    } else {
      resetProgressBar();
    }
  });

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-me2627-variant-select]');
    if (!select) return;

    var root = select.closest('[data-me2627-buy]');
    if (!root) return;

    var script = root.querySelector('script[data-me2627-product-json]');
    if (!script) return;

    var product;
    try {
      product = JSON.parse(script.textContent);
    } catch (error) {
      return;
    }

    var variantId = parseInt(select.value, 10);
    var variant = (product.variants || []).find(function (item) { return item.id === variantId; });
    if (!variant) return;

    var price = root.querySelector('[data-me2627-price]');
    var compare = root.querySelector('[data-me2627-compare]');
    var stock = root.querySelector('[data-me2627-stock]');
    var hiddenInput = root.querySelector('input[name="id"]');
    var submit = root.querySelector('[data-me2627-submit]');

    function formatMoney(cents) {
      return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
    }

    if (price) price.textContent = formatMoney(variant.price);

    if (compare) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compare.hidden = false;
        compare.textContent = formatMoney(variant.compare_at_price);
      } else {
        compare.hidden = true;
        compare.textContent = '';
      }
    }

    if (stock) {
      stock.textContent = variant.available ? stock.getAttribute('data-label-available') : stock.getAttribute('data-label-soldout');
      stock.classList.toggle('is-soldout', !variant.available);
    }

    if (hiddenInput) hiddenInput.value = String(variant.id);
    if (submit) submit.disabled = !variant.available;
  });

  document.addEventListener('click', function (event) {
    var sizeButton = event.target.closest('[data-me2627-size]');
    if (!sizeButton || sizeButton.disabled) return;

    var root = sizeButton.closest('[data-me2627-buy]');
    if (!root) return;

    var sizeButtons = root.querySelectorAll('[data-me2627-size]');
    sizeButtons.forEach(function (node) {
      node.classList.remove('is-active');
      node.setAttribute('aria-pressed', 'false');
    });

    sizeButton.classList.add('is-active');
    sizeButton.setAttribute('aria-pressed', 'true');

    var variantId = sizeButton.getAttribute('data-variant-id');
    var select = root.querySelector('[data-me2627-variant-select]');
    if (!select) return;
    select.value = variantId;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-me2627-form]');
    if (!form) return;
    event.preventDefault();

    var root = form.closest('[data-me2627-buy]');
    if (!root) return;

    var feedback = root.querySelector('[data-me2627-feedback]');
    var error = root.querySelector('[data-me2627-error]');
    var submit = root.querySelector('[data-me2627-submit]');
    var submitLabel = root.querySelector('[data-me2627-submit-label]');
    var formData = new FormData(form);
    var variantId = formData.get('id');

    if (!variantId) {
      if (error) {
        error.hidden = false;
        error.textContent = 'Veuillez choisir une taille.';
      }
      return;
    }

    if (error) {
      error.hidden = true;
      error.textContent = '';
    }
    if (feedback) {
      feedback.hidden = true;
      feedback.textContent = '';
    }

    if (submit) submit.disabled = true;
    if (submitLabel) submitLabel.textContent = 'Ajout en cours...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1
      })
    })
      .then(function (response) { return response.json(); })
      .then(function (payload) {
        if (payload.status) throw new Error(payload.description || 'Erreur lors de l’ajout au panier.');

        if (feedback) {
          feedback.hidden = false;
          feedback.textContent = 'Produit ajouté au panier.';
        }

        var drawerCountTargets = document.querySelectorAll('[data-cart-count], .cart-count-bubble span, .header__cart-count');
        if (drawerCountTargets.length) {
          fetch('/cart.js')
            .then(function (response) { return response.json(); })
            .then(function (cart) {
              drawerCountTargets.forEach(function (node) {
                node.textContent = cart.item_count;
              });
            })
            .catch(function () {});
        }
      })
      .catch(function (errorObject) {
        if (error) {
          error.hidden = false;
          error.textContent = errorObject.message || 'Une erreur est survenue.';
        }
      })
      .finally(function () {
        if (submitLabel) submitLabel.textContent = 'Ajouter au panier';
        var select = root.querySelector('[data-me2627-variant-select]');
        var selectedOption = select && select.selectedOptions && select.selectedOptions[0];
        if (submit) submit.disabled = !!(selectedOption && selectedOption.dataset.available === 'false');
      });
  });
})();
